// src/components/Wordmark.jsx
// Wordmark em texto que imita o logo.png: "D" claro, "•Rec" laranja.
import "./Wordmark.css";

function Wordmark({ className = "" }) {
  return (
    <span className={`wordmark ${className}`} aria-label="D•Rec">
      <span className="wordmark-d">D</span>
      <span className="wordmark-rec">•Rec</span>
    </span>
  );
}

export default Wordmark;
